export enum PathStoreEnum {
  PATH_STORE_IMAGE = "image",
  PATH_STORE_PDF = "pdf",
}
